<template>
  <div>
    <HeroSection theme="blue-gradient">
      <h1 class="display-12 text-white font-size-md-down-5 font-weight-semi-bold">
        Create a <span class="text-warning">MortgageWatch</span> Alert...
      </h1>
      <p class="text-white">
        Our MortgageWatch service never sleeps and is constantly talking to all UK lenders to find the latest mortgage deals,
        so create a MortgageWatch alert today to find deals and start saving!
      </p>
      <!--      <button v-if="!wizarding" class="btn btn-success" @click="openWizard()">Open Wizard</button>-->
    </HeroSection>
    <b-overlay :show="saving" :opacity="0.3">
      <IntroductionToMortgageWatch v-if="!wizarding" class="space-top-1 space-bottom-0"
                                   size="sm"
                                   theme="remortgage/introduction"
                                   hide-title 
                                   custom-cta 
                                   custom-cta-text="Let's get started..." @clicked="wizarding = true"/>
      <div class="space-top-1 space-bottom-2">
        <transition name="fade">
          <div v-if="wizarding" class="">
            <div class="container">
              <MortgageWizard :wizard="form" 
                              @completed="wizardCompleted($event)"
                              @close="wizardClosed()"
                              :allow-close="true"/>
            </div>
          </div>
        </transition>
        <div v-if="showProducts" class="">
          <div class="">
            <ProductExplorer 
                v-if="searchQuery != null" 
                :query="searchQuery" 
                :filters="null" 
                disable-search-modal 
                @retry="openWizard()" />
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
  import HeroSection from "@/components/layout/HeroSection";
  import ProductExplorer from "@/components/ProductExplorer";
  import {mapGetters, mapActions } from "vuex";
  import MortgageWizard from "@/components/MortgageWizard";
  import {MortgageWatchQuery} from "@/utils/MortgageWatchQuery.ts";
  import ProductQuerySummary from "@/components/products/ProductQuerySummary";
  import IntroductionToMortgageWatch from "@/components/home/IntroductionToMortgageWatch";
  
  export default {
    name: "GettingStarted",
    
    data() {
      return {
        wizarding: false,
        editMode: true,
        searchQuery: null,
        form: null,
        mortgageWatch: null,
        saving: false
      }
    },
    
    components: {
      IntroductionToMortgageWatch,
      HeroSection,
      MortgageWizard,
      ProductExplorer
    },
    
    computed: {
      ...mapGetters([
        "allLenders",
        "watchers", "userWatchers", "mostRecentWatcher", "getWatcher",
        "currentUser", "isLoggedIn"
      ]),
      
      showProducts() {
        return this.searchQuery != null && !this.wizarding;
      }
    },

    methods: {
      ...mapActions([
         "addWatcher", "saveUserWatcher"
      ]),
      
      openWizard() {
        this.wizarding = true;
      },
      
      wizardClosed() {
        this.wizarding = false;
      },
      
      async wizardCompleted(event) {
        this.saving = true;
        this.mortgageWatch = new MortgageWatchQuery(event);
        this.form = { ...this.mortgageWatch };
        await this.saveUserWatcher({owner: this.currentUser.email, data: this.form});
        await this.$router.push(
            { name: "mortgage-watch-by-id",
              params: {
                id: this.mortgageWatch.uid,
                name: "test"
              }
        });
        this.saving = false;
      }
    }
  }
</script>
